module.exports = " <svg version=1.1 class=fa-icon :class=clazz :role=\"label ? 'img' : 'presentation'\" :aria-label=label :width=width :height=height :view-box.camel=box :style=style> <path :d=icon.d /> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome/src/components/Icon.vue
// module id = 345
// module chunks = 2